import * as React from 'react';
import { observer } from 'mobx-react';
import * as classNames from 'classnames';

// Styles
const s = require('./CircleButton.css');

// Enumerables
export enum ECircleButtonType {
    Default
}

// Props
interface ICircleButtonProps {
    onClick?: ((e: React.MouseEvent<HTMLButtonElement>) => void) | null;
    className?: string | null;
    type?: ECircleButtonType;
    iconElement?: JSX.Element | null;
    iconClassName?: string | null;
}

// Component
@observer
export class CircleButton extends React.Component<ICircleButtonProps, {}> {
    static get defaultProps(): ICircleButtonProps {
        return {
            onClick: null,
            className: null,
            type: ECircleButtonType.Default
        };
    }

    public render() {
        // Destructure
        const { className, type, iconClassName, iconElement } = this.props;

        // Render
        return (
            <button onClick={this.handleButtonClick} className={classNames(s.button, this.props.className)}>
                {this.props.children}
            </button>
        );
    }

    private handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        if (this.props.onClick) {
            this.props.onClick(e);
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/action/CircleButton.tsx